import { t } from "i18next";
import styles from "./InvalidTypeInput.module.scss";

export interface IInvalidTypeInputProps {
    className?: string;
}

export function InvalidTypeInput(props: IInvalidTypeInputProps) {
    return <div className={`${styles.host} ${props.className ?? ""}`}>{t("invalid_type_input")}</div>
}